import React from 'react';

const DevTooltip: React.FC<{ children: React.ReactNode; componentName?: string }> = ({
  children,
}) => <>{children}</>;

export default DevTooltip;
